module.exports = {"key":"hello french","submit":"Envoyez votre opinion!","hide":"Cachez ceci","skip":"Passez à la prochaine question","placeholder":"Merci de décrire votre état la-dessus..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr.json
// module id = 441
// module chunks = 0